import SettlementDetailsModule from './SettlementDetails.module';

export default SettlementDetailsModule;
